import * as React from "react";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import { MUIDataTableMeta } from "mui-datatables";
import * as DatiFide from "../../../DatiFide";
import { Trad } from "../../../components";

export const GetEconomicDataListColumns = (baseUrl: string) => [
    {
        name: "ID_DatoEconomico",
        label: "ID",
        options: {
            filter: false
        }
    },
    {
        name: "Data",
        label: Trad.Trad("Data"),
        options: {
            filter: false,
            customBodyRender: (val: Date) => Trad.Trad(val)
        }
    },
    {
        name: "AnnoBilancio",
        label: Trad.Trad("Anno Bilancio"),
        options: {
            filter: false
        }
    },
    {
        name: "AnnoUnico",
        label: Trad.Trad("Anno Unico"),
        options: {
            filter: false
        }
    },
    {
        name: "Fatturato",
        label: Trad.Trad("Fatturato"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.TradParam("{1-I}", [val]),
            setCellProps: () => ({
                align: "right"
            })
        }
    },
    {
        name: "ValoreProduzioneUltimoAnno",
        label: Trad.Trad("Valore Produzione Ultimo Anno"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.TradParam("{1-I}", [val]),
            setCellProps: () => ({
                align: "right"
            })
        }
    },
    {
        name: "ValoreProduzioneAnnoPrecedente",
        label: Trad.Trad("Valore produzione anno precedente"),
        options: {
            filter: false,
            customBodyRender: (val: string) => Trad.TradParam("{1-I}", [val]),
            setCellProps: () => ({
                align: "right"
            })
        }
    },
    {
        name: "Edit",
        label: Trad.Trad("Modifica"),
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => ({
                align: "center"
            }),
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                const rowData = { ...new DatiFide.CDatiFideValutazione(), ...tableMeta.tableData[tableMeta.rowIndex] };

                return (
                    <a href={`${baseUrl}/${rowData.ID_DatoEconomico}`}>
                        <Tooltip title={Trad.Trad("Modifica")}>
                            <IconButton aria-label="edit" size="small">
                                <EditIcon />
                            </IconButton>
                        </Tooltip>
                    </a>
                );
            }
        }
    }
];



// WEBPACK FOOTER //
// ./src/inar2/components/EconomicDataList/EconomicDataListColumns.tsx